import { useContext } from 'react'
import PropTypes from 'prop-types'
import { Stack, SubHeading, Visible, Hidden } from '@leroy-merlin-br/backyard-react-ui'
import LazyLoad from 'react-lazyload'

import slugify from 'scripts/utils/slugify'

import { ModularContext } from 'reactSite/Modular/contexts/ModularContext'

import SVGS from 'reactUtils/svgs'
import Icon from 'reactUtils/Icon'

import * as S from './styled'

const IMAGE_SIZE = 125

const CategoryItem = ({ item, onClick }) => {
  const { isBlackWeekend } = useContext(ModularContext)
  const { name, url, picture } = item

  const handleClick = event => {
    if (onClick) {
      onClick(event, item)
    }
  }

  const renderImg = () => {
    const svgSlug = slugify(name)

    if (Object.keys(SVGS.header).includes(svgSlug)) {
      return (
        <S.Thumbnail as="div" isSvg imageSize={IMAGE_SIZE} isBlackWeekend={isBlackWeekend}>
          <Icon icon={svgSlug} name={slugify(name)} />
        </S.Thumbnail>
      )
    }

    return <S.Thumbnail src={picture} alt={name} title={name} imageSize={IMAGE_SIZE} itemProp="image" />
  }

  return (
    <div
      itemScope="itemscope"
      itemType="http://www.schema.org/SiteNavigationElement"
    >
      <S.Item href={url} title={name} itemProp="url" onClick={handleClick}>
        <Stack spacing="byte" align="left">
          <LazyLoad height={IMAGE_SIZE} offset={200} once>
            {renderImg()}
          </LazyLoad>

          <div>
            <Visible untilKilo kilo>
              <SubHeading as="h3" size="kilo" align="center" itemProp="name" noMargin>{name}</SubHeading>
            </Visible>

            <Hidden untilKilo kilo>
              <SubHeading as="h3" size="mega" align="center" itemProp="name" noMargin>{name}</SubHeading>
            </Hidden>
          </div>
        </Stack>
      </S.Item>
    </div>
  )
}

CategoryItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    picture: PropTypes.url,
    url: PropTypes.url
  }).isRequired,
  onClick: PropTypes.func
}

export default CategoryItem
